module.exports = __webpack_public_path__ + "static/media/1015175.c266f0bf.jpg";